import React, {useContext} from 'react';
import PusherContext from './PusherContext';

const PusherProvider = ({ pusher, children }) => {
  return (
    <PusherContext.Provider displayName="PusherProvider" value={pusher}>
      {children}
    </PusherContext.Provider>
  );
};

export const usePusher = () => {
  return useContext(PusherContext);
};

export default PusherProvider;
